import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { createStaticBreadcrumbs } from "src/routing/breadcrumbs";

import SetPageBreadcrumbs from "./SetPageBreadcrumbs";

/**
 * Registers static breadcrumbs derived from the current pathname.
 *
 * Postconditions: Query-string-only changes do not recalculate this pathname-based list.
 */
const StaticRouteBreadcrumbs = () => {
    const { pathname } = useLocation();
    const breadcrumbs = useMemo(() => createStaticBreadcrumbs(pathname), [pathname]);

    return (
        <SetPageBreadcrumbs
            owner="route"
            breadcrumbs={breadcrumbs}
        />
    );
};

export default StaticRouteBreadcrumbs;
